// Role
export const ROLE_MANAGER = 'manager'
export const ROLE_FACILITATOR = 'facilitator'
export const ROLE_PARTICIPANT = 'participant'

// Toast notification
export const TOAST_OFFERING_INSTANCE_INFO_ID = 'offering-info'

// Profile image max size
export const MAX_PROFILE_PHOTO_SIZE = 5 * 1024 * 1024 // 5MB

export const FRONTEND_URL =
  process.env.REACT_APP_ENVIRONMENT === 'development'
    ? 'http://localhost:3000'
    : process.env.REACT_APP_ENVIRONMENT === 'internal'
    ? 'https://tmc-internal.smartfirm.com'
    : process.env.REACT_APP_ENVIRONMENT === 'staging'
    ? 'https://protmc-staging.smartfirm.com'
    : process.env.REACT_APP_ENVIRONMENT === 'production'
    ? 'https://pprotivitisc.com'
    : 'https://pprotivitisc.com'

export const SERVER_GRAPHQL =
  process.env.REACT_APP_ENVIRONMENT === 'development'
    ? 'http://tmc-backend.ddev.site:33000/graphql'
    : process.env.REACT_APP_ENVIRONMENT === 'internal'
    ? 'https://tmc-internal-api.smartfirm.com/graphql'
    : process.env.REACT_APP_ENVIRONMENT === 'staging'
    ? 'https://tmcrefreshapi-staging.smartfirm.com/graphql'
    : process.env.REACT_APP_ENVIRONMENT === 'production'
    ? 'https://pprotivitisc.com/graphql'
    : 'https://pprotivitisc.com/graphql'

export const AUTH_DATA_KEY =
  process.env.REACT_APP_ENVIRONMENT === 'development'
    ? 'epCoreDevAuthData'
    : process.env.REACT_APP_ENVIRONMENT === 'internal'
    ? 'epCoreInternalAuthData'
    : process.env.REACT_APP_ENVIRONMENT === 'staging'
    ? 'epCoreStagingAuthData'
    : process.env.REACT_APP_ENVIRONMENT === 'production'
    ? 'epTMCAuthData'
    : ''
